import { colors } from "../../Styles";

export function Start({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M199.84,131.77c-13.78-8.06-75.39-47.36-79.33-49.89-10.93-7.01-20.34-2.95-20.34,7.8v107.47c0,7.31,11.8,11.14,20.69,5.48,15.4-9.81,75.2-48.19,78.98-51.15,3.89-3.05,13.78-11.64,0-19.7h0Z"/>
      <path d="M141.73,9.29C68.71,9.29,9.29,68.71,9.29,141.73s59.41,132.44,132.44,132.44,132.44-59.41,132.44-132.44S214.76,9.29,141.73,9.29ZM141.73,248.18c-58.7,0-106.45-47.75-106.45-106.45s47.75-106.45,106.45-106.45,106.45,47.75,106.45,106.45-47.75,106.45-106.45,106.45Z"/>
    </svg>
  );
}
